import React from 'react';
import { Clock } from 'lucide-react';

const SIZES = {
  xs: 'h-7 px-2 text-[10px] gap-1 rounded-md',
  sm: 'h-7 px-3 text-[11px] gap-1 rounded-lg',
  md: 'h-8 px-3 text-xs gap-1.5 rounded-full',
  lg: 'h-12 px-6 text-base gap-2 rounded-full',
  // Fills the Categories card's action slot (same height as Add).
  slot: 'h-8 w-full px-2 text-[10px] gap-1 rounded-full',
};
const ICONS = { xs: 'w-3 h-3', sm: 'w-3 h-3', md: 'w-3.5 h-3.5', lg: 'w-5 h-5', slot: 'w-3 h-3' };

/**
 * Stands in for a product card's Add button when the product is Coming Soon
 * (utils/comingSoon.js): it says so and can't be pressed. `className` places
 * it where that card's Add button would be.
 */
export const ComingSoonButton = ({ size = 'md', className = '', testId }) => (
  <button
    type="button"
    disabled
    aria-disabled="true"
    title="This product will be available soon"
    className={`inline-flex items-center justify-center whitespace-nowrap font-semibold cursor-not-allowed select-none border border-amber-300 bg-amber-50 text-amber-700 ${SIZES[size] || SIZES.md} ${className}`}
    data-testid={testId}
  >
    <Clock className={`shrink-0 ${ICONS[size] || ICONS.md}`} aria-hidden="true" />
    Coming Soon
  </button>
);
